import React from "react";
//#region types
import { AuthHelper } from "utils/helpers";
//#endregion
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region components
import Layout from "components/layout/layout";
import RouterSwitch from "./switch";
import { LoginContainer } from "components/login";
import { EULAView } from "components/eula";
//#endregion

const CompanyRoute: React.FC = () => {
  const { isAuthenticated } = useSelector((store: AppState) => ({
    isAuthenticated: store.auth.isAuthorized,
  }));

  const showEULA = useSelector((store: AppState) => store.auth.loggedInUser.unsignedEula);

  return AuthHelper.authenticate() || isAuthenticated ? (
    showEULA ? (
      <EULAView />
    ) : (
      <Layout>
        <RouterSwitch />
      </Layout>
    )
  ) : (
    <LoginContainer />
  );
};

export default CompanyRoute;
